// hooks/useClockOffset.js: M4-14 Preact subscriber for clock offset.
//
// The room-ws service exposes a `subscribeClockOffset(listener)` API
// that fires whenever a PONG lands and updates the EWMA-smoothed offset.
// This hook adapts it to a Preact-friendly state value.
//
// Defaults are 0/0, the timer bars render correctly while we wait for
// the first PONG (M4-14 AC #3: bar lands at 0 if the event arrives
// after the deadline; no fabricated timeout).

import { useEffect, useState } from 'preact/hooks';

/**
 * @param {{ service: any|null }} opts
 * @returns {{ clockOffsetMs: number, rttMs: number }}
 */
export function useClockOffset({ service }) {
  const [state, setState] = useState(() => {
    if (service && typeof service.getClockOffset === 'function') {
      return service.getClockOffset();
    }
    return { clockOffsetMs: 0, rttMs: 0 };
  });

  useEffect(() => {
    if (!service || typeof service.subscribeClockOffset !== 'function') return undefined;
    // Seed from current value in case a PONG already landed.
    if (typeof service.getClockOffset === 'function') {
      setState(service.getClockOffset());
    }
    return service.subscribeClockOffset((next) => setState(next));
  }, [service]);

  return state;
}
